<template>
  <div class="content-experiences-grid-empty">
    <Icon
      icon="search"
      class="text-4xl"
    />
    <h2 class="mt-3">
      {{ $t("no_results_found") }}
    </h2>
    <div class="mt-2">
      <Markdown
        v-if="searchTerm"
        as="p"
        :text="$t('no_results_matching', { term: searchTerm })"
      />
      <p v-else-if="error">
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  error?: any
  searchTerm?: string
}>()

const { t } = useI18n()

const errorMessage = computed(() => props.error?.data?.message || t('content_experiences_load_error'))
</script>

<style>
.content-experiences-grid-empty {
  @apply col-span-full flex h-96 flex-col items-center justify-center bg-gray-50;

  > p {
    @apply text-xs font-medium text-gray-500;
  }
}
</style>
